import {
	GET_EVENT_DETAIL_START, GET_EVENT_DETAIL, GET_EVENT_PLAYLIST_START, GET_EVENT_PLAYLIST,
} from '../constants/index';

const initialState = {};

const event = (state = initialState, {type, seoName, data}) => {
	switch (type) {
		case GET_EVENT_DETAIL_START:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: null,
						isLoading: true,
					},
				},
			};
		case GET_EVENT_DETAIL: {
			let info = null;
			if (JSON.stringify(data) === '{}') {
				info = {
					seoName,
					noAccess: true,
					code: 'Failed',
				};
			} else if (data
					&& ((data.code && data.code.toLowerCase() === 'failed')
							|| (data.message && data.message.toLowerCase() === 'failed'))) {
				info = {
					seoName,
					noAccess: true,
					code: 'Failed',
				};
			} else if (data
					&& ((data.code && data.code.toLowerCase() === 'failedgeo')
							|| (data.message && data.message.toLowerCase() === 'failedgeo'))) {
				info = {
					seoName,
					noAccess: true,
					code: 'Blackout',
				};
			} else {
				info = {
					seoName,
					...data,
					noAccess: undefined,
					code: data.blackout ? 'Blackout' : undefined,
					type: 'game',
				};
			}
			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: info,
						isLoading: false,
					},
				},
			};
		}
		case GET_EVENT_PLAYLIST_START:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					playlist: {
						data: null,
						isLoading: true,
					},
				},
			};
		case GET_EVENT_PLAYLIST:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					playlist: {
						data: data.map((game, index) => ({...game, index})),
						isLoading: false,
					},
				},
			};
		default:
			return state;
	}
};

export default event;
